// Change your display name on tha landing display
const header = {
    name: "Luiz Felipe Rosa da Silveira",
}
const background = {
    // Options: Snow or Particle
    type: "Particle"
}
// Write a para about yourself here
// To update your image, go to './styles/images.css'
const section2title = "About me"
const about = {
    paragraph: "My name is Luiz Felipe, I'm 25 years old, Brazilian, MMA fighter and I'm about to graduate in Information Systems at UNICAMP!",
    paragraph2:"Since I was a child, I am totally enthusiastic about Visual Effects, which led me into an autodidact path of exploring how dynamic things were made, experimenting and studying technologies, until I had my first contact w/ programming in High School.",
    paragraph3:"During College, I immersed myself into the Computer Graphics and Software Engineering area, which leveraged my problem solving skills, attention to details, and systematic and algebraic thinking, boosting me towards learning Front-End and Back-End Development, as well as Data Analysis and Machine Learning."

}
// Edit your skill and the percentage you know about it
// To Add a skill, copy any one below and paste it after the last comma
const skillsBar = [
    {
        name: "Python",
        value: 90
    },{
        name: "HTML5 & CSS3",
        value: 75
    },{
        name: "Javascript (Vanilla & ReactJs)",
        value: 80
    },{
        name: "Game Development (Unity3D w/ C#  & Unreal Engine w/ C++)",
        value: 80
    },{
        name: "SQL (MySQL / PostgreSQL)",
        value: 75
    },{
        name: "Adobe CC (Photoshop, After Effects, Illustrator, XD)",
        value: 75
    },
]
// Edit your projects, its name, your skills used to make it, and the url. 
// You can omit freely anything if you dont have it
// To Add a Project, copy any one below and paste it after the last comma and increment the id's project number
const section3Title = "Projects"
const projects = [
    {
        // Add image in './styles/images.css' in #project1
        id: "project1",
        name: "PizzaDaQuebrada",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/PizzaDaQuebrada"
    },
    {
        // Add image in './styles/images.css' in #project2
        id: "project2",
        name: "Bigodex",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/PokedexReactJs"
    },
    {
        // Add image in './styles/images.css' in #project3
        id: "project3",
        name: "FilmesBacanas",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/FilmesBacanasJS"
    },
    {
        // Add image in './styles/images.css' in #project4
        id: "project4",
        name: "ParedãoDoBatidão",
        skills: ["HTML, CSS, JS"],
        url: "https://github.com/luizfelipers19/ParedaoDoBatidaoJS"
    },
    {
        // Add image in './styles/images.css' in #project5
        id: "project5",
        name: "MyTravelAgency",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/homeBusPage"
    },
    {
        // Add image in './styles/images.css' in #project6
        id: "project6",
        name: "TCC - KinectMocap",
        skills: ["Unity3D & C#, Kinect v2"],
        url: "https://www.youtube.com/watch?v=OwKWLGqD4no"
    },{
        // Add image in './styles/images.css' in #project4
        id: "project7",
        name: "AnimePedia",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/AnimesDBv2"
    },{
        // Add image in './styles/images.css' in #project4
        id: "project8",
        name: "ContadorJS - Covid19",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/CovidTrackerJS"
    },
    {
        // Add image in './styles/images.css' in #project4
        id: "project9",
        name: "CriptoPreçosJS",
        skills: ["HTML, CSS, JS"],
        url: "https://github.com/luizfelipers19/CriptoPrecoJs"
    },
    {
        // Add image in './styles/images.css' in #project4
        id: "project10",
        name: "SinfoniaJS",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/ParedaoDoBatidaoJS"
    },{
        // Add image in './styles/images.css' in #project4
        id: "project11",
        name: "BreakingBadPedia",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/ReactJsBreakingBadAPI"
    },{
        // Add image in './styles/images.css' in #project4
        id: "project12",
        name: "TeslaUIClone",
        skills: ["HTML, CSS, JS & ReactJS"],
        url: "https://github.com/luizfelipers19/TeslaUI"
    },
    
]
// Edit your Miscellaneous Activities, its name and the url. 
// You can omit freely anything if you dont have it
// To Add a Activity, copy any one below and paste it after the last comma and increment the id's Miscellaneous number
const section4Title = "VFX and Animations"
const miscellaneous = [
    {
        // Add image in './styles/images.css' in #misc1
        id: "misc1",
        name: "MyStarWarsStory",
        url: "https://www.youtube.com/watch?v=XvhA6JyxowE"
    },
    {
        // Add image in './styles/images.css' in #misc2        
        id: "misc2",
        name: "ParqueDeEmoções",
        url: "https://youtu.be/GXiavbVoSQM"
    },
    {
        // Add image in './styles/images.css' in #misc3
        id: "misc3",
        name: "Animaception",
        url: "https://www.youtube.com/watch?v=ckrLro3A578"
    },
]
// Contact form text, and Jotforms link
// To get your own jotform link, go to https://www.jotform.com/
// If you hacve the link already, paste it in the contactUrl below
const section5Title = "Contact"
const contact = {
    pitch: "Feel free to send me a message at any time, Bitcoins, pay me a coffee, or even tell me about a cool idea you've had. I'd love to hear more from you, so just send a direct mail to the address below!",
    copyright: "Luiz Felipe Rosa da Silveira",
    contactUrl: ''
}
// Paste your respective social media links. You can omit any if you dont have it
// Upload your resume in your drive, get the shaareable link and paste it in the resume section
const social = {
    github: 'https://github.com/luizfelipers19',
  /* 
  facebook: 'https://facebook.com',
    linkedin: 'https://linkedin.com',
    instagram: 'https://instagram.com',
    resume: 'https://novoresume.com/'
  */ 
}
// Dont change anything here
export { header, background, about, skillsBar, projects, miscellaneous, contact, social, section2title, section3Title, section4Title, section5Title }